export async function getMemberAdmissionPayments(base, memberId, signal) {
    const r = await fetch(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/admission-payments`, { credentials: 'include', signal: signal ?? null, headers: { Accept: 'application/json' } });
    const b = await r.json();
    if (!r.ok)
        throw new Error(b.message ?? 'No se pudieron consultar los pagos de ingreso.');
    return b;
}
export async function recordMemberAdmissionPayment(base, memberId, input) {
    const r = await fetch(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/admission-payments`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/pdf',
            'X-Urbanik-Assignment-Id': encodeURIComponent(input.assignmentId),
            'X-Urbanik-Joined-On': encodeURIComponent(input.joinedOn),
            'X-Urbanik-Amount': encodeURIComponent(input.amount),
            'X-Urbanik-Paid-On': encodeURIComponent(input.paidOn),
            'X-Urbanik-Reference': encodeURIComponent(input.reference),
            'X-Urbanik-Payment-Method': encodeURIComponent(input.paymentMethod),
            'X-Urbanik-Notes': encodeURIComponent(input.notes),
            'X-Urbanik-Reason': encodeURIComponent(input.reason),
            'X-Urbanik-File-Name': encodeURIComponent(input.file.name),
        },
        body: input.file,
    });
    const b = await r.json();
    if (!r.ok)
        throw new Error(b.message ?? 'No se pudo registrar el pago de ingreso.');
    return b;
}
export async function verifyMemberAdmission(base, memberId, input) {
    const r = await fetch(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/admission-verification`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/pdf',
            'X-Urbanik-Assignment-Id': encodeURIComponent(input.assignmentId),
            'X-Urbanik-Joined-On': encodeURIComponent(input.joinedOn),
            'X-Urbanik-Reference': encodeURIComponent(input.reference),
            'X-Urbanik-Reason': encodeURIComponent(input.reason),
            'X-Urbanik-File-Name': encodeURIComponent(input.file.name),
        },
        body: input.file,
    });
    const body = await r.json();
    if (!r.ok)
        throw new Error(body.message ?? 'No se pudo verificar la fecha.');
    return body;
}
export async function previewAdmissionRecalculation(base, memberId, assignmentId) {
    const response = await fetch(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/admission-recalculations/${encodeURIComponent(assignmentId)}`, { credentials: 'include', headers: { Accept: 'application/json' } }), body = await response.json();
    if (!response.ok)
        throw new Error(body.message ?? 'No pudimos calcular la vista previa.');
    return body;
}
export async function confirmAdmissionRecalculation(base, memberId, assignmentId) {
    const response = await fetch(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/admission-recalculations/${encodeURIComponent(assignmentId)}/confirm`, { method: 'POST', credentials: 'include', headers: { Accept: 'application/json' } }), body = await response.json();
    if (!response.ok)
        throw new Error(body.message ?? 'No pudimos confirmar el recálculo.');
    return body;
}
export async function downloadMemberEntryReceipt(base, memberId, paymentId) {
    const r = await fetch(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/admission-payments/${encodeURIComponent(paymentId)}/receipt`, { credentials: 'include' });
    if (!r.ok)
        throw new Error('No se pudo descargar el comprobante.');
    return r.blob();
}
